<template>
   <div class="card">
      <div class="card-body m-2">
         <div class="row p-2 align-items-center">

            <div class="col-12 d-flex flex-wrap align-items-center mb-2">
               <!-- Search -->
               <div class="me-2" style="width: 220px;">
                  <input v-model="search" type="text" class="form-control form-control-sm"
                     placeholder="&#xF002; Search cloud storage..."
                     style="border-radius:8px; height: 36px; font-size: 13px; font-family: 'Roboto', sans-serif, 'Font Awesome 6 Free'; font-weight: 900;"
                     @keyup="onSearch()" />
               </div>

               <!-- Add button -->
               <div class="me-auto">
                  <button type="button" class="fw-bold btn btn-sm text-light"
                     style="font-size: 13px; height: 36px; border-radius: 8px !important; padding: 0 1.2rem; white-space: nowrap; background: #00A0C1;"
                     @click="openAddModal()">
                     <i class="fa-solid fa-plus me-1"></i> Add Cloud Storage
                  </button>
               </div>

               <!-- Filters -->
               <div class="d-flex align-items-center me-2">
                  <span class="p-1 filterTitle">Sort by:</span>
                  <select v-model="sortBy" class="form-select shadow-none filterOptions bordered-select" style="font-size: 13px;">
                     <option v-for="s in sortByList" :value="s.value" :key="s.value">{{ s.text }}</option>
                  </select>
               </div>

               <div class="d-flex align-items-center me-2">
                  <span class="p-1 filterTitle">Rows:</span>
                  <select v-model="pagination.pageSize"
                     class="form-select form-select-sm shadow-none filterOptions bordered-select" style="width: auto; font-size: 13px;">
                     <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text }}</option>
                  </select>
               </div>

               <div class="pagination" v-if="pagination.totalItems > 0">
                  <button @click="previousPage()" :disabled="pagination.page == 1" class="pagination-arrow">
                     <i class="fa fa-chevron-left"></i>
                  </button>
                  <span class="pagination-label">
                     <strong>{{ paginationLabel }}</strong> of {{ pagination.totalItems }}
                  </span>
                  <button @click="nextPage()"
                     :disabled="pagination.page == pagination.totalPages || pagination.totalItems == 0"
                     class="pagination-arrow">
                     <i class="fa fa-chevron-right"></i>
                  </button>
               </div>
            </div>
         </div>

         <!-- Table -->
         <div class="row p-2">
            <table class="table align-middle mainTable">
               <thead class="align-middle">
                  <tr>
                     <th scope="col">Website</th>
                     <th scope="col" style="width: 100px;">Actions</th>
                  </tr>
               </thead>

               <tbody v-if="pagination.totalItems <= 0">
                  <tr>
                     <td colspan="2">No records to display.</td>
                  </tr>
               </tbody>

               <tbody v-else>
                  <tr v-for="(cs, index) in commonCloudStorage" :key="index">
                     <td style="font-family: monospace; font-size: 13px;">
                        <i class="fa-solid fa-cloud me-2" style="color: #90a4ae;"></i>
                        {{ cs.website }}
                     </td>
                     <td>
                        <div class="d-flex gap-2">
                           <button type="button" class="ms-action-btn ms-action-btn--edit"
                              title="Edit" @click="openEditModal(cs)">
                              <i class="fa-solid fa-pen"></i>
                           </button>
                           <button type="button" class="ms-action-btn ms-action-btn--delete"
                              title="Delete" @click="confirmDelete(cs)">
                              <i class="fa-solid fa-xmark"></i>
                           </button>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>

      </div>
   </div>

   <!-- Add / Edit Modal -->
   <div class="modal-backdrop-custom" v-if="showFormModal" @click.self="closeFormModal()">
      <div class="modal-content-custom">
         <button @click="closeFormModal()" class="close-button-custom">&times;</button>
         <h5 class="modal-title-custom">
            <i class="fa-solid fa-cloud me-2" style="color: #00A0C1;"></i>
            {{ editId ? 'Edit Cloud Storage' : 'Add Cloud Storage' }}
         </h5>
         <hr>
         <div class="modal-body-custom">
            <label class="filter-label">Website Domain</label>
            <input type="text" class="form-control form-control-sm"
               style="border-radius: 8px;" placeholder="e.g. drive.google.com"
               v-model="inputWebsite" v-on:keyup.enter="editId ? editCommonCloudStorage() : addCommonCloudStorage()">
         </div>
         <div class="modal-footer-custom">
            <button type="button" class="btn btn-sm btn-modal-cancel" @click="closeFormModal()">Cancel</button>
            <button v-if="!editId" type="button" class="btn btn-sm text-light" style="background: #00A0C1; border-radius: 8px;"
               @click="addCommonCloudStorage()">
               <i class="fa-solid fa-plus me-1"></i> Add
            </button>
            <button v-else type="button" class="btn btn-sm text-light" style="background: #00A0C1; border-radius: 8px;"
               @click="editCommonCloudStorage()">
               <i class="fa-solid fa-floppy-disk me-1"></i> Save
            </button>
         </div>
      </div>
   </div>

   <!-- Delete Confirm Modal -->
   <div class="modal-backdrop-custom" v-if="showDeleteModal" @click.self="showDeleteModal = false">
      <div class="modal-content-custom">
         <button @click="showDeleteModal = false" class="close-button-custom">&times;</button>
         <h5 class="modal-title-custom">
            <i class="fa-solid fa-xmark me-2" style="color: #c62828;"></i>
            Delete Cloud Storage
         </h5>
         <hr>
         <div class="modal-body-custom">
            <p>Are you sure you want to delete this cloud storage domain?</p>
            <div class="site-display">{{ deleteWebsiteName }}</div>
         </div>
         <div class="modal-footer-custom">
            <button type="button" class="btn btn-sm btn-modal-cancel" @click="showDeleteModal = false">Cancel</button>
            <button type="button" class="btn btn-sm text-light" style="background: #c62828; border-radius: 8px;"
               @click="deleteCommonCloudStorage()">
               <i class="fa-solid fa-xmark me-1"></i> Delete
            </button>
         </div>
      </div>
   </div>
</template>

<script>
import moment from 'moment'
import { debounce, extractErrorMessage } from '@/plugins/helper.js'

export default {
   data() {
      return {
         showFormModal: false,
         showDeleteModal: false,
         deleteID: 0,
         deleteWebsiteName: '',
         editId: null,
         search: "",
         commonCloudStorage: [],
         inputWebsite: "",
         debounceFn: null,
         paginationData: {},
         pagination: {
            pageSize: 50, page: 1, totalItems: 0, totalPages: 1,
         },
         rowsPerPageList: [
            { text: "50", value: 50 },
            { text: "75", value: 75 },
            { text: "100", value: 100 },
         ],
         sortByList: [
            { text: "Date: Newest", value: "date_created__desc" },
            { text: "Date: Oldest", value: "date_created__asc" },
            { text: "Website: A-Z", value: "website__asc" },
            { text: "Website: Z-A", value: "website__desc" },
         ],
         sortBy: "date_created__desc",
         sorting: { field: "date_created", order: "desc" },
      }
   },

   computed: {
      paginationLabel() {
         var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
         var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)
         return start + " - " + end
      },
      currentPage() { return this.pagination.page },
      rowsPerPage() { return this.pagination.pageSize },
      sortItems() { return this.sortBy },
   },

   watch: {
      currentPage() { this.getCommonCloudStorage() },
      rowsPerPage() { this.pagination.page = 1; this.getCommonCloudStorage() },
      sortItems() {
         if (this.sortBy.includes("__")) {
            let sort = this.sortBy.split("__")
            this.sorting.field = sort[0]
            this.sorting.order = sort[1]
         } else {
            this.sorting.field = this.sortBy
            this.sorting.order = ""
         }
         this.getCommonCloudStorage()
      },
   },

   created() {
      this.debounceFn = debounce(() => this.getCommonCloudStorage(), 500)
      this.getCommonCloudStorage()
   },

   methods: {
      formatDate(date) { return moment(date).format("DD-MMM-YYYY, hh:mm A") },

      isValidDomain(domain) {
         const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
         return domainPattern.test(domain);
      },

      resetValues() { this.inputWebsite = ""; this.editId = null; },

      openAddModal() { this.resetValues(); this.showFormModal = true; },

      openEditModal(cs) {
         this.inputWebsite = cs.website;
         this.editId = cs.id;
         this.showFormModal = true;
      },

      closeFormModal() { this.showFormModal = false; this.resetValues(); },

      confirmDelete(cs) {
         this.deleteID = cs.id;
         this.deleteWebsiteName = cs.website;
         this.showDeleteModal = true;
      },

      previousPage() { this.pagination.page > 1 ? this.pagination.page -= 1 : '' },
      nextPage() { this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : '' },
      onSearch() { this.pagination.page = 1; this.debounceFn() },

      async addCommonCloudStorage() {
         try {
            if (!this.inputWebsite || !this.isValidDomain(this.inputWebsite)) {
               this.$toast.error("Please provide a valid domain."); return;
            }
            const payload = { website: this.inputWebsite }
            const resp = await this.$axios.post("admin-controls/create-common-cloud-storage", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
               this.getCommonCloudStorage()
            }
            this.closeFormModal()
         } catch (error) {
            console.log(error)
            this.$toast.error(extractErrorMessage(error, "Failed to add common cloud storage domain."))
            this.closeFormModal()
         }
      },

      async editCommonCloudStorage() {
         try {
            if (!this.inputWebsite || !this.isValidDomain(this.inputWebsite)) {
               this.$toast.error("Please provide a valid domain."); return;
            }
            const payload = { id: this.editId, website: this.inputWebsite }
            const resp = await this.$axios.post("admin-controls/update-common-cloud-storage", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
               this.getCommonCloudStorage()
            }
            this.closeFormModal()
         } catch (error) {
            console.log(error)
            this.$toast.error(extractErrorMessage(error, "Failed to update common cloud storage domain."))
            this.closeFormModal()
         }
      },

      async deleteCommonCloudStorage() {
         try {
            const resp = await this.$axios.delete("admin-controls/remove-common-cloud-storage/" + this.deleteID)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
               this.getCommonCloudStorage()
            }
            this.deleteID = 0; this.deleteWebsiteName = '';
            this.showDeleteModal = false;
         } catch (error) {
            console.log(error)
            this.$toast.error(extractErrorMessage(error, "Failed to remove common cloud storage domain."))
            this.deleteID = 0; this.showDeleteModal = false;
         }
      },

      async getCommonCloudStorage() {
         let apiPath = "admin-controls/get-common-cloud-storage?page_size=" + this.pagination.pageSize + "&page=" + this.pagination.page

         if (this.sorting.order != "" && this.sorting.field != "") {
            apiPath += "&order_by=" + this.sorting.order
            apiPath += "&field=" + this.sorting.field
         }
         if (this.search !== "" || this.search !== null) {
            apiPath += "&website=" + this.search
         }

         await this.$axios.get(apiPath)
            .then((response) => {
               if (response.data.common_cloud_storage === "No Record Found")
                  this.commonCloudStorage = []
               else {
                  this.commonCloudStorage = response.data.common_cloud_storage
               }
               this.paginationData = response.data.pagination
               this.pagination.totalItems = this.paginationData.total_count
               this.pagination.totalPages = Math.ceil(this.paginationData.total_count / this.pagination.pageSize)
            })
            .catch((error) => {
               this.$toast.error(extractErrorMessage(error, "Failed to load common cloud storage domains."))
            })
      },
   },
}
</script>

<style scoped>
.card { border: none; }

/* Action buttons */
.btn-action {
   width: 30px; height: 30px; padding: 0;
   border-radius: 6px; display: inline-flex;
   align-items: center; justify-content: center;
   font-size: 12px; transition: all 0.15s ease;
}
.btn-action-edit { border: 1px solid #00A0C1; color: #00A0C1; background: #fff; }
.btn-action-edit:hover { background: #00A0C1; color: #fff; }
.btn-action-delete { border: 1px solid #c62828; color: #c62828; background: #fff; }
.btn-action-delete:hover { background: #c62828; color: #fff; }

/* Site display in delete modal */
.site-display {
   font-family: monospace; font-size: 13px;
   background: #fde8ea; padding: 8px 12px;
   border-radius: 8px; color: #c62828; word-break: break-all;
}

/* Modal */
.modal-backdrop-custom {
   position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
   background-color: rgba(0,0,0,0.5); display: flex;
   justify-content: center; align-items: center; z-index: 1050;
}
.modal-content-custom {
   position: relative; background: #fff; padding: 2rem;
   border-radius: 14px; width: 100%; max-width: 500px;
   box-shadow: 0 8px 30px rgba(0,0,0,0.2);
}
.modal-title-custom { font-weight: 700; font-size: 1.1rem; color: #435666; margin-bottom: 0; }
.modal-content-custom hr { margin: 0.75rem 0 1rem; border-color: #e9ecef; }
.close-button-custom {
   position: absolute; top: 0.75rem; right: 1rem;
   font-size: 1.8rem; font-weight: bold; line-height: 1;
   color: #adb5bd; background: none; border: none; cursor: pointer;
}
.close-button-custom:hover { color: #435666; }
.modal-body-custom { font-size: 14px; color: #435666; }
.filter-label {
   font-size: 11px; font-weight: 600; color: #6c757d;
   text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 4px; display: block;
}
.modal-footer-custom { margin-top: 1rem; display: flex; justify-content: flex-end; gap: 8px; }
.btn-modal-cancel { background: #e9ecef; border: none; border-radius: 8px; color: #435666; }
</style>